import App from './App.svelte';
import axios from 'axios'
import { removeCookie } from 'tiny-cookie'
import { cleanUserStore, showLockInfo } from './store'
import { User } from './roles'
import Keycloak from 'keycloak-js'
import { API } from './api/api.js'

//axios.defaults.baseURL = process.env.ROLLUP_WATCH ? 'http://localhost:8110' : '/'
axios.defaults.withCredentials = true

axios.interceptors.response.use((response) => {
	return response
}, (error) => {
	if (error.response.status === 401) {
		removeCookie('XSRF-TOKEN')
		removeCookie('auth_token')
		cleanUserStore()
	}

  if (error.response.status === 423) {
  	 showLockInfo()
	}
	return Promise.reject(error)
})

const user = new User()
user.checkAuth().then(authenticated => {
	if (!authenticated) {
		// user.login()
		console.log('[DEBUG] not authenticated', )
	}
})

const ssoHostURL = new API().ssoHostURL()
let initOptions = {
	url: ssoHostURL,
	realm: 'my-flexlink',
	clientId: 'myflexlink',
	onLoad: 'check-sso',
	silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso'
}

let keycloak = new Keycloak(initOptions);

keycloak.init({ onLoad: initOptions.onLoad }).then((auth) => {
	if (!auth) {
		console.info("Not Authenticated");
	} else {
		console.info("Authenticated");
	}
})

const app = new App({
	target: document.getElementById('app')
});

export default app;
